/**
 * @generated SignedSource<<723f96bbf4ce2b36898c26d706ad55b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SalesforceUpdateRecordsInput = {
  clientMutationId?: string | null;
  recordsChanges: ReadonlyArray<SalesforceRecordObjectUpdate>;
};
export type SalesforceRecordObjectUpdate = {
  fields: ReadonlyArray<SalesforceRecordFieldUpdate>;
  objectName: string;
  recordId: string;
};
export type SalesforceRecordFieldUpdate = {
  name: string;
  value: string;
};
export type SalesforcePanelUpdateRecordsMutation$variables = {
  input: SalesforceUpdateRecordsInput;
};
export type SalesforcePanelUpdateRecordsMutation$data = {
  readonly salesforceUpdateRecords: {
    readonly updatedRecords: ReadonlyArray<{
      readonly errors: ReadonlyArray<{
        readonly message: string;
      }> | null;
      readonly fieldName: string | null;
      readonly objectName: string;
      readonly success: boolean | null;
    } | null> | null;
  } | null;
};
export type SalesforcePanelUpdateRecordsMutation = {
  response: SalesforcePanelUpdateRecordsMutation$data;
  variables: SalesforcePanelUpdateRecordsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SalesforceUpdateRecordsPayload",
    "kind": "LinkedField",
    "name": "salesforceUpdateRecords",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesforceRecordUpdateResponse",
        "kind": "LinkedField",
        "name": "updatedRecords",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesforceRecordUpdateError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "objectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fieldName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforcePanelUpdateRecordsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforcePanelUpdateRecordsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c0b15494d0897582758288a64c22dbda",
    "id": null,
    "metadata": {},
    "name": "SalesforcePanelUpdateRecordsMutation",
    "operationKind": "mutation",
    "text": "mutation SalesforcePanelUpdateRecordsMutation(\n  $input: SalesforceUpdateRecordsInput!\n) {\n  salesforceUpdateRecords(input: $input) {\n    updatedRecords {\n      success\n      errors {\n        message\n      }\n      objectName\n      fieldName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "252a3f0e3807634d0b37ae2f51dd6b5d";

export default node;
